import React, { type ReactElement } from 'react';
import { UnhandledErrorPageBlock } from '../index';
import { Box, ContentBlock } from 'braid-design-system';

interface Props {
  children: ReactElement;
}

class AppErrorBoundary extends React.Component<Props> {
  state = { hasError: false };

  componentDidCatch() {
    this.setState({ hasError: true });
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;
    if (hasError) {
      return (
        <ContentBlock>
          <Box margin="small">
            <UnhandledErrorPageBlock />
          </Box>
        </ContentBlock>
      );
    }

    return children;
  }
}

export default AppErrorBoundary;
